import { useMemo } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { AlgomerchTag, CoreFlightsComponent } from "@b2bportal/core-types";
import type { HSBCAlgomerchTag } from "@hsbc/types";
import { AlgomerchTags } from "@tenant/flights";
import { FlightTime, FlightSummaryDetails } from "./components";
import styles from "./styles.module.scss";

export const FlightCardSummary = (props) => {
  const { tags } = props;
  // Remove BestQuality from everywhere as they could be misleading sometimes
  const filteredTags: HSBCAlgomerchTag[] = useMemo(
    () =>
      (tags ?? []).filter(
        (tag: AlgomerchTag) => tag !== AlgomerchTag.BestQuality
      ),
    [tags]
  );

  const [block, cn] = useModuleBEM(
    styles,
    CoreFlightsComponent.FlightCardSummary
  );

  return (
    <div className={block}>
      {filteredTags.length > 0 && (
        <div className={cn("flight-tags")}>
          <AlgomerchTags {...props} tags={filteredTags} />
        </div>
      )}

      <FlightTime {...props} />

      <div className={cn("divider")} />

      <FlightSummaryDetails {...props} />
    </div>
  );
};
